// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"po-z","badgeLink":"qo-z","category":"ro-z"};